import { observer } from 'mobx-react';

import 'dropzone/dist/basic.css';
import 'dropzone/dist/dropzone.css';
import { useCallback, useEffect, useRef, ReactNode } from 'react';

import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import {
    getStorageAdapater,
    StorageTarget
} from '@assets/firebase/StorageAdapater';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as style from './StorageUpload.module.less';
import classNames from 'classnames';
const { Dropzone } = require('dropzone');

interface IStorageUpload {
    display: string | ReactNode;
    toasterMessage: string;
    storageTarget: StorageTarget;
    className?: string;
    onUpload?: (fileName: string) => void;
    allowedExtensions?: string[];
}

export const StorageUpload = observer((props: IStorageUpload) => {
    const dropzoneRef = useRef(null);
    const propsRef = useRef(props);
    propsRef.current = props;

    useEffect(() => {
        let myDropzone = new Dropzone(dropzoneRef.current, {
            dictDefaultMessage: '',
            maxFilesize: 20, // MB
            url: '/',
            addRemoveLinks: false,
            method: 'put',
            chunking: true,
            forceChunking: true,
            autoQueue: false,
            autoProcessQueue: false,
            disablePreviews: true
        });

        myDropzone.on('addedfile', async function (file) {
            const { storageTarget, toasterMessage, onUpload, allowedExtensions } = propsRef.current;
            const storage = getStorageAdapater();
            const name = file.name;
            const exts = allowedExtensions ?? ['.pdf'];
            if (!exts.some(ext => name.toLowerCase().endsWith(ext))) {
                toast.error(`Please upload a supported file (${exts.join(', ')})`);
                myDropzone.removeFile(file);
                return;
            }
            const fb = getFirebase();
            const fileExists = false;
            if (!fileExists) {
                const message = toasterMessage.replace('%name%', name);
                var toasterId = toast.info(message, {
                    progress: 0,
                    autoClose: false
                });

                //alert('Uploading file');
                const success = await storage.uploadFileToStorage(
                    storageTarget,
                    file,
                    progress => {
                        //file.upload.progress = progress;
                        toast.update(toasterId, {
                            progress: progress / 100
                        });
                    }
                );

                if (success) {
                    //alert('Upload done!');
                    if (onUpload) {
                        onUpload(name);
                    }
                    toast.done(toasterId);
                } else {
                    toast.info('Trouble uploading the file..');
                }
            } else {
                //alert('File already exists');
            }
        });

        return () => {
            while (myDropzone.files.length > 0) {
                myDropzone.removeFile(myDropzone.files[0]);
            }

            myDropzone.destroy();
        };
    }, []);

    const clsToUse = classNames(style.taskPageDropZone, props.className);
    return (
        //Click is handled by drop-zone
        <Button ref={dropzoneRef} className={clsToUse} variant="light">
            {props.display}
        </Button>
    );
});
